import axios from '../../axios-dashboard';

import * as actionTypes from './actionTypes';

export const forgotPasswordStart = () => {
    return {
        type: actionTypes.FORGOT_PASSWORD_START
    }
};

export const forgotPasswordSuccess = () => {
    return {
        type: actionTypes.FORGOT_PASSWORD_SUCCESS
    }
};

export const forgotPasswordFail = (error) => {
    return {
        type: actionTypes.FORGOT_PASSWORD_FAIL,
        error: error
    }
};

export const forgotPassword = (email) => {
    return dispatch => {
        dispatch(forgotPasswordStart());
        const forgotPassword = {
            email: email
        };
        const url = "/forgot-password";
        axios.post(url, forgotPassword)
            .then(response => {
                dispatch(forgotPasswordSuccess())
            })
            .catch(err => {
                dispatch(forgotPasswordFail(err.response.data.error))
            })
    }
};